import trans from 'js/utilities/trans';

const VALIDATION_STATE_CLASSES = [
    'is-valid',
    'is-invalid',
    'hf-validated',
    'hf-valid',
    'hf-invalid',
    'hf-user-valid',
    'hf-user-invalid',
    'hf-in-range',
    'hf-out-of-range',
];

const clearValidationState = (form) => {
    form.querySelectorAll('.form-control, .form-select, .form-check-input').forEach((control) => {
        control.classList.remove(...VALIDATION_STATE_CLASSES);
        control.removeAttribute('aria-invalid');
    });
};

const applicationForms = document.querySelectorAll('[data-application-form]');

if (applicationForms.length > 0) {
    applicationForms.forEach((form) => {
        form.addEventListener('reset', () => clearValidationState(form));

        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const submitButton = form.querySelector('button[type="submit"]');
            const buttonText = submitButton?.querySelector('.btn__text');
            const errorMessage = form.querySelector('[data-error-message]');
            const successMessage = form.querySelector('[data-success-message]');
            const vacancyId = form.dataset.vacancyId;
            const successUrl = form.dataset.successUrl;
            const originalButtonText = form.dataset.buttonText;

            errorMessage.classList.add('d-none');
            successMessage.classList.add('d-none');

            if (!form.reportValidity()) {
                return;
            }

            if (!vacancyId) {
                errorMessage.textContent = trans('app.application_form.error.no_vacancy_id');
                errorMessage.classList.remove('d-none');
                return;
            }

            if (submitButton) {
                submitButton.disabled = true;
                if (buttonText) {
                    buttonText.textContent = trans('app.application_form.submitting');
                }
            }

            try {
                const formData = new FormData(form);
                formData.append('vacancyId', vacancyId);

                const response = await fetch('/api/applications', {
                    method: 'POST',
                    body: formData,
                });

                const result = await response.json();

                if (response.ok && result.success) {
                    if (successUrl) {
                        window.location.href = successUrl;
                    } else {
                        successMessage.textContent = result.message || trans('app.application_form.success');
                        successMessage.classList.remove('d-none');
                        form.reset();
                        successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                } else {
                    clearValidationState(form);

                    if (result.errors) {
                        Object.keys(result.errors).forEach(fieldName => {
                            const field = form.querySelector(`[name="${fieldName}"]`);
                            if (field) {
                                field.classList.add('is-invalid');
                            }
                        });
                        errorMessage.textContent = Object.values(result.errors).join(', ');
                    } else {
                        errorMessage.textContent = result.message || trans('app.application_form.error.generic');
                    }
                    errorMessage.classList.remove('d-none');
                    errorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            } catch (error) {
                console.error('Application form error:', error);
                errorMessage.textContent = trans('app.application_form.error.unexpected');
                errorMessage.classList.remove('d-none');
            } finally {
                if (submitButton) {
                    submitButton.disabled = false;
                    if (buttonText) {
                        buttonText.textContent = originalButtonText;
                    }
                }
            }
        });
    });
}

// Toggle "Anders, namelijk" veld
const informationSourceSelects = document.querySelectorAll('[data-information-source]');

informationSourceSelects.forEach((select) => {
    const form = select.closest('form');
    const wrapper = form?.querySelector('[data-information-source-other-wrapper]');
    const input = wrapper?.querySelector('[data-information-source-other]');

    if (!wrapper || !input) {
        return;
    }

    const toggleOtherField = () => {
        const isOther = select.value === 'other';

        wrapper.classList.toggle('d-none', !isOther);
        input.disabled = !isOther;
        input.required = isOther;

        if (!isOther) {
            input.value = '';
        }
    };

    select.addEventListener('change', toggleOtherField);

    form.addEventListener('reset', () => {
        setTimeout(toggleOtherField, 0);
    });

    toggleOtherField();
});

